<template>
  <div class="about-page notranslate" ref="pageBg">
    <banner nav-public theme="dark-text"></banner>
    <main>
      <header class="hero container-medium center">
        <h2 v-t>We make saving and investing ridiculously easy.</h2>
        <img src="../images/about/coins.png" id="coins-img" alt="Image of Canadian coins">
      </header>

      <section class="container-small">
        <p class="section-title"><strong v-t>What We Do</strong></p>
        <p v-t>CI Direct Investing makes it easy to build your financial future with convenient online savings and investing tools, and financial advice at your fingertips.</p>
        <p v-t><strong>Effortlessly invest</strong> for your future with a professionally-managed portfolio that’s matched to your goals.</p>
        <p v-t><strong>Put your savings to work</strong> at the touch of a button with high-interest savings.</p>
        <p v-t><strong>Get answers to your money questions</strong> anytime, anywhere, so you can make smart moves.</p>
        <p v-t><strong>Build a brighter future</strong> with financial advice and retirement planning included in your already low fee.</p>
        </ul>
      </section>
      <div id="scroll-container">
        <div ref="missionBg" id="mission-bg"></div>
        <div class="scroll-step" id="mission" ref="mission">
          <section class="container-small">
            <p class="section-title"><strong v-t>Our Mission</strong></p>
            <h3 v-t>Financial empowerment for all Canadians.</h3>
            <p v-t>You shouldn’t need an inheritance or a six-figure salary to access quality investments and advice. We exist to give Canadians an easy and affordable way to build a brighter financial future, whether they’re starting with $1,000, or $1 million.</p>
          </section>
        </div>

        <div class="scroll-step" id="team-bg">

          <section class="container-small">
            <p class="section-title"><strong v-t>Our Team</strong></p>
            <p v-t>CI Direct Investing is part of CI Financial, one of the country’s largest investment companies, trusted by Canadians since 1965.</p>
            <p>
              <span v-t>The CI Direct Investing team is made up of experienced investment managers, financial planners, analysts, software engineers, customer support representatives, and more. Our team works hard to deliver an </span>
              <a href="https://www.google.com/search?q=google+reviews+wealthbar&oq=google+reviews+wealthbar&aqs=chrome..69i57j69i64.3208j0j7&sourceid=chrome&ie=UTF-8#lrd=0x54867179b5d4fda5:0x874265811073f6f5,1" target="_blank" v-t>exceptional investing experience</a>
              <span v-t>for Canadians from coast to coast.</span>
            </p>
          </section>

        <!-- end scrolling step -->
        </div>
      </div>
      <cta></cta>

    </main>
    <footer-component></footer-component>
  </div>
</template>

<script>
  // polyfill for scrollama features
  import 'intersection-observer';
  import scrollama from 'scrollama';

  import Banner from '@layoutTheme/banner';
  import Footer from '@layoutTheme/footer';
  import cta from '~vue/components/cta';

  const scroller = scrollama();

  export default {
    components: {
      Banner,
      cta,
      'footer-component': Footer,
    },
    data() {
      return {
        bg: this.$refs.missionBg,
        bgSet: false,
      };
    },
    mounted() {
      this.handleResize();

      scroller
        .setup({
          step: '.scroll-step',
        })
        .onStepEnter(this.handleStepEnter)
        .onStepExit(this.handleStepExit);

      window.addEventListener('resize', this.handleResize);
      this.unSetBGListener();
    },
    methods: {
      unSetBGListener() {
        this.$refs.missionBg.addEventListener('transitionend', () => {
          if (!this.bgSet) {
            this.$refs.missionBg.style.zIndex = -10;
          }
        });
      },
      handleStepEnter(response) {
        this.bgSet = false;
        if (response.index === 0) {
          this.$refs.missionBg.style.zIndex = 10;
          this.bgSet = true;
          this.$refs.missionBg.classList.add('show');
          this.$refs.mission.classList.add('show');
        }
        this.$refs.pageBg.classList.add('white');
      },
      handleStepExit(response) {
        this.bgSet = false;
        if (response.index === 0) {
          this.$refs.missionBg.classList.remove('show');
          this.$refs.mission.classList.remove('show');
        }
        if (response.direction === 'up') {
          this.$refs.pageBg.classList.remove('white');
        }
        // this.unSetBG();
      },
      handleResize() {
        scroller.resize();
      },
    },
  };
</script>
<style lang="scss" scoped>
  .about-page {
    background: $bg-50;
    &.white { background: white; }
  }
  img {
    max-width: 100%;
    height: auto;
  }
  .hero h2 {
    transition: all 1s ease;
    margin-top: 6rem;
    @media #{$screen-width-large} {
      margin-top: 10rem;
    }
  }
  #coins-img {
    transition: all 1s ease;
    margin: 2rem 0 6rem;
    width: 100%;
    max-width: 32rem;
    @media #{$screen-width-large} {
      margin: 2rem 0 10rem;
      padding: 0;
    }
  }

  #mission-bg {
    position: fixed;
    top: 0;
    left: 0;
    background: $primary-500;
    height: 100vh;
    width: 100vw;
    z-index: -10;
    opacity: 0;
    transition: opacity 1s ease;
    &.show { opacity: 1; }
  }

  #mission {
    z-index: 11;
    padding: 4rem 0;
    transition: all 1s ease;
    &.show {
      color: white;
      .section-title strong {
        color: white;
        border-color: white;
      }
    }
    @media #{$screen-width-medium} { padding: 10rem 0; }
  }

  #team-bg { padding-bottom: 10rem; }

  .section-title {
    strong {
      display: inline-block;
      transition: all 1s ease;
      color: $secondary-500;
      padding-bottom: 1rem;
      border-bottom: 1px solid $primary-300;
    }
  }
  figcaption {
    margin-top: 0.5rem;
    p { margin-bottom: 0.5rem; }
  }
  #scroll-container { border-bottom: 1px solid $neutral-300; }
  .split-text { @media #{$screen-width-medium} { margin-bottom: 2.25rem; }  }
  .step { max-width: inherit; } // Hack to get around bug from Peak-Style. Delete when fixed there

</style>
